import React from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import moment from 'moment';

const ConfirmReabilitarNegativacao = ({ show, parcelas, onConfirm, onRejeitar }) => {
  const formatarValor = (v) =>
    Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  return (
    <Modal show={show} onHide={onRejeitar} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Reabilitação de Negativação</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Cliente com título(s) negativado(s). Deseja excluir parcela(s) da negativação?</strong>
        </p>
        {parcelas && parcelas.length > 0 && (
          <div className="table-responsive">
            <Table striped bordered size="sm">
              <thead>
                <tr>
                  <th>Título</th>
                  <th>Ordem</th>
                  <th>Vencimento</th>
                  <th>Valor</th>
                  <th>Órgão</th>
                </tr>
              </thead>
              <tbody>
                {parcelas.map((p) => (
                  <tr key={`${p.codigo_titulo}-${p.numero_de_ordem}`}>
                    <td>{p.codigo_titulo}</td>
                    <td>{p.numero_de_ordem}</td>
                    <td>
                      {p.data_vencimento
                        ? moment(p.data_vencimento).format('DD/MM/YYYY')
                        : '—'}
                    </td>
                    <td>{formatarValor(p.valor || 0)}</td>
                    <td>{p.orgao_negativador || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onConfirm}>
          Sim
        </Button>
        <Button variant="secondary" onClick={onRejeitar}>
          Não
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmReabilitarNegativacao;
